import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { type LucideIcon } from 'lucide-react';

interface PageHeaderActionProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
}

export const PageHeaderAction = ({ icon: Icon, label, onClick }: PageHeaderActionProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='ghost'
            size='icon'
            onClick={onClick}
            className={cn(
              'size-7 shrink-0 cursor-pointer transition-colors',
              'hover:bg-accent hover:text-accent-foreground'
            )}
            aria-label={label}
          >
            <Icon className='size-4' />
          </Button>
        </TooltipTrigger>
        <TooltipContent side='bottom'>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
